export enum IncomeVerificationEnum {
  INCOME_VERIFICATION_DOCUMENTS = 'income-verification-documents-',
  INCOME_VERIFICATION_DOCUMENTS_DISPLAY_LAST_PAGE = 'income-verification-documents-display-last-page-'
}
